(function () {
  var query = window.matchMedia('(max-width: 767px)');
  function syncFooterMenus() {
    var menus = document.querySelectorAll('.site-footer .footer-menu-accordion');
    for (var i = 0; i < menus.length; i += 1) {
      var summary = menus[i].querySelector('summary');
      if (summary && !summary.getAttribute('data-footer-menu-bound')) {
        summary.setAttribute('data-footer-menu-bound', 'true');
        summary.addEventListener('click', function (event) {
          if (query.matches) {
            event.preventDefault();
            var menu = event.currentTarget.parentNode;
            menu.open = !menu.open;
          }
        });
      }
      if (query.matches) {
        menus[i].removeAttribute('open');
      } else {
        menus[i].setAttribute('open', '');
      }
    }
  }
  syncFooterMenus();
  if (query.addEventListener) {
    query.addEventListener('change', syncFooterMenus);
  } else {
    query.addListener(syncFooterMenus);
  }
}());
